export default "__VITE_ASSET__C93_Yy7M__"